export default __webpack_public_path__ + "static/media/employee-directory.bee83dda.png";